module.exports = __webpack_public_path__ + "static/media/thGrid.4c517d81.svg";